const collections = [
  {
    title: '台北娜娜全追踪',
    desc: '最新动态、独家专访、深度分析全覆盖',
    count: 128,
    tag: '热门',
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20photography%20of%20entertainment%20news%20and%20media%20concept%2C%20soft%20coral%20and%20golden%20accents%2C%20modern%20magazine%20layout%20aesthetic%20with%20floating%20headlines%20and%20abstract%20geometric%20elements%2C%20clean%20sophisticated%20background%2C%20high%20quality&width=600&height=400&seq=index-taipei-nana&orientation=landscape',
  },
  {
    title: '莫里秀独家合集',
    desc: '所有莫里秀相关爆料一条不落',
    count: 96,
    tag: '新上',
    image: 'https://readdy.ai/api/search-image?query=Soft%20editorial%20style%20image%20of%20digital%20media%20content%20collage%20with%20amber%20and%20warm%20gray%20tones%2C%20abstract%20data%20visualization%20aesthetic%2C%20modern%20media%20branding%20concept%20on%20clean%20light%20background%2C%20professional%20magazine%20design&width=600&height=400&seq=index-mori-show&orientation=landscape',
  },
  {
    title: '玩偶姐姐深度追踪',
    desc: '从最新爆料到过往合集，一网打尽',
    count: 85,
    tag: '爆款',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20editorial%20concept%20photography%20with%20warm%20coral%20pink%20and%20gold%20gradients%2C%20abstract%20floating%20media%20cards%20on%20soft%20neutral%20background%2C%20modern%20entertainment%20news%20visual%20identity%2C%20sophisticated%20and%20clean%20aesthetic&width=600&height=400&seq=index-doll-sis&orientation=landscape',
  },
  {
    title: '娱乐圈最新爆料',
    desc: '全明星阵容，每日更新热门八卦',
    count: 256,
    tag: '日更',
    image: 'https://readdy.ai/api/search-image?query=Modern%20editorial%20photography%20style%20with%20overlapping%20media%20elements%20in%20warm%20earth%20tones%2C%20golden%20and%20terracotta%20color%20palette%2C%20abstract%20news%20headlines%20floating%20on%20light%20cream%20background%2C%20professional%20media%20aesthetic&width=600&height=400&seq=index-celeb-news&orientation=landscape',
  },
  {
    title: '吃瓜视频精选',
    desc: '高清视频合集，热门人物精彩瞬间',
    count: 312,
    tag: '精选',
    image: 'https://readdy.ai/api/search-image?query=Contemporary%20editorial%20image%20of%20video%20content%20and%20media%20playback%20concept%2C%20warm%20golden%20and%20coral%20light%20accents%2C%20abstract%20geometric%20play%20buttons%20and%20thumbnails%20on%20soft%20neutral%20background%2C%20modern%20digital%20media%20style&width=600&height=400&seq=index-video-picks&orientation=landscape',
  },
  {
    title: '热门话题讨论区',
    desc: '百万网友在线互动，吃瓜群众聚集地',
    count: 540,
    tag: '活跃',
    image: 'https://readdy.ai/api/search-image?query=Warm%20editorial%20style%20image%20of%20social%20media%20conversation%20and%20community%20engagement%20concept%2C%20coral%20and%20gold%20accent%20colors%2C%20abstract%20speech%20bubbles%20and%20interaction%20elements%20on%20clean%20light%20background%2C%20modern%20digital%20community%20aesthetic&width=600&height=400&seq=index-hot-topics&orientation=landscape',
  },
  {
    title: '独家内幕专区',
    desc: '深度调查报道，只有51吃瓜才能看到',
    count: 67,
    tag: '独家',
    image: 'https://readdy.ai/api/search-image?query=Sophisticated%20editorial%20photography%20of%20exclusive%20investigative%20journalism%20concept%2C%20warm%20amber%20and%20terracotta%20color%20palette%2C%20abstract%20magnifying%20glass%20and%20document%20elements%20on%20clean%20neutral%20background%2C%20professional%20newsroom%20aesthetic&width=600&height=400&seq=index-exclusive&orientation=landscape',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            专题合集
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            精选七大专题，帮你快速找到最想看的吃瓜内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {collections.map((item, i) => (
            <div
              key={i}
              className={`group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-200/70 ${
                i === 0 ? 'sm:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className="relative overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-40 object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 text-[11px] font-medium rounded-full bg-accent-500 text-white">
                  {item.tag}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-900 mb-1.5">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2">
                  {item.desc}
                </p>
                <span className="text-xs text-foreground-400">
                  <span className="w-3 h-3 inline-flex items-center justify-center mr-1">
                    <i className="ri-file-text-line"></i>
                  </span>
                  {item.count} 条内容
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}